// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Contenedor Principal de la Sección ===== */
.Ourclients_testimonialsSection__m\\+nJX {
  padding: 80px 5%;
  background-color: #FFFFFF;
  width: 100%;
}

.Ourclients_container__uDxot {
  max-width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  border-top: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}

.Ourclients_title__NnSNv {
  font-size: 36px;
  font-weight: 800;
  text-align: center;
  color: var(--textoNegro);
  margin-bottom: 60px;
}

/* ===== Estructura del Carrusel ===== */
.Ourclients_carouselContainer__5ap5m {
  position: relative;
  padding: 0 60px; /* Espacio para los botones en desktop */
}

.Ourclients_carouselWindow__cfIzW {
  overflow: hidden;
}

.Ourclients_carouselTrack__RPwHQ {
  display: flex;
  transition: transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* ===== Tarjeta de Testimonio Individual ===== */
.Ourclients_testimonialCard__veGUM {
  flex: 0 0 100%; /* Cada tarjeta ocupa el 100% de la ventana */
  box-sizing: border-box;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.Ourclients_testimonialCard__veGUM blockquote p {
  font-size: 22px;
  font-style: italic;
  color: #333;
  line-height: 1.6;
  margin-bottom: 30px;
  max-width: 800px; /* Evita que el texto se estire demasiado en pantallas anchas */
}

.Ourclients_testimonialCard__veGUM figcaption {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Ourclients_clientPhoto__FYyWt {
  width: 250px;

  margin-bottom: 20px;

  
}

.Ourclients_clientName__E03\\+Q {
  font-weight: 700;
  font-size: 18px;
  color: var(--textoNegro);
}

.Ourclients_clientRole__wlv4i {
  font-size: 16px;
  color: #555;
}

/* ===== Botones de Navegación ===== */
.Ourclients_navButton__7KV6P {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  z-index: 10;
  transition: all 0.2s ease;
}
.Ourclients_navButton__7KV6P:hover {
  background-color: #f5f5f5;
  transform: translateY(-50%) scale(1.1);
}
.Ourclients_navButton__7KV6P svg {
  width: 24px;
  height: 24px;
}
.Ourclients_prev__1-OJZ { left: 0; }
.Ourclients_next__EDzKN { right: 0; }


/* ======================================= */
/* ===== MEDIA QUERY PARA MÓVILES ===== */
/* ======================================= */
@media (max-width: 767px) {
  .Ourclients_container__uDxot {
    padding: 30px 0;
  }
  .Ourclients_title__NnSNv {
    font-size: 28px;
    margin-bottom: 40px;
  }
  .Ourclients_carouselContainer__5ap5m {
    padding: 0;
  }
  .Ourclients_testimonialCard__veGUM blockquote p {
    font-size: 18px;
  }
  .Ourclients_clientPhoto__FYyWt {
   
  }
  .Ourclients_navButton__7KV6P {
    /* display: none; */
    width: 30px;
    height: 30px;
  }
  .Ourclients_navButton__7KV6P svg{
    width: 30px;
    height: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Ourclients.module.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,eAAe,EAAE,wCAAwC;AAC3D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;AAC7D;;AAEA,iDAAiD;AACjD;EACE,cAAc,EAAE,6CAA6C;EAC7D,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB,EAAE,+DAA+D;AACnF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;;EAEZ,mBAAmB;;;AAGrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA,0BAAQ,OAAO,EAAE;AACjB,0BAAQ,QAAQ,EAAE;;;AAGlB,4CAA4C;AAC5C,yCAAyC;AACzC,4CAA4C;AAC5C;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;;EAEA;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* ===== Contenedor Principal de la Sección ===== */\n.testimonialsSection {\n  padding: 80px 5%;\n  background-color: #FFFFFF;\n  width: 100%;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 50px 0;\n  border-top: 1px solid #d0d0d0;\n  border-bottom: 1px solid #d0d0d0;\n}\n\n.title {\n  font-size: 36px;\n  font-weight: 800;\n  text-align: center;\n  color: var(--textoNegro);\n  margin-bottom: 60px;\n}\n\n/* ===== Estructura del Carrusel ===== */\n.carouselContainer {\n  position: relative;\n  padding: 0 60px; /* Espacio para los botones en desktop */\n}\n\n.carouselWindow {\n  overflow: hidden;\n}\n\n.carouselTrack {\n  display: flex;\n  transition: transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n/* ===== Tarjeta de Testimonio Individual ===== */\n.testimonialCard {\n  flex: 0 0 100%; /* Cada tarjeta ocupa el 100% de la ventana */\n  box-sizing: border-box;\n  padding: 0 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.testimonialCard blockquote p {\n  font-size: 22px;\n  font-style: italic;\n  color: #333;\n  line-height: 1.6;\n  margin-bottom: 30px;\n  max-width: 800px; /* Evita que el texto se estire demasiado en pantallas anchas */\n}\n\n.testimonialCard figcaption {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.clientPhoto {\n  width: 250px;\n\n  margin-bottom: 20px;\n\n  \n}\n\n.clientName {\n  font-weight: 700;\n  font-size: 18px;\n  color: var(--textoNegro);\n}\n\n.clientRole {\n  font-size: 16px;\n  color: #555;\n}\n\n/* ===== Botones de Navegación ===== */\n.navButton {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n  z-index: 10;\n  transition: all 0.2s ease;\n}\n.navButton:hover {\n  background-color: #f5f5f5;\n  transform: translateY(-50%) scale(1.1);\n}\n.navButton svg {\n  width: 24px;\n  height: 24px;\n}\n.prev { left: 0; }\n.next { right: 0; }\n\n\n/* ======================================= */\n/* ===== MEDIA QUERY PARA MÓVILES ===== */\n/* ======================================= */\n@media (max-width: 767px) {\n  .container {\n    padding: 30px 0;\n  }\n  .title {\n    font-size: 28px;\n    margin-bottom: 40px;\n  }\n  .carouselContainer {\n    padding: 0;\n  }\n  .testimonialCard blockquote p {\n    font-size: 18px;\n  }\n  .clientPhoto {\n   \n  }\n  .navButton {\n    /* display: none; */\n    width: 30px;\n    height: 30px;\n  }\n  .navButton svg{\n    width: 30px;\n    height: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"testimonialsSection": `Ourclients_testimonialsSection__m+nJX`,
	"container": `Ourclients_container__uDxot`,
	"title": `Ourclients_title__NnSNv`,
	"carouselContainer": `Ourclients_carouselContainer__5ap5m`,
	"carouselWindow": `Ourclients_carouselWindow__cfIzW`,
	"carouselTrack": `Ourclients_carouselTrack__RPwHQ`,
	"testimonialCard": `Ourclients_testimonialCard__veGUM`,
	"clientPhoto": `Ourclients_clientPhoto__FYyWt`,
	"clientName": `Ourclients_clientName__E03+Q`,
	"clientRole": `Ourclients_clientRole__wlv4i`,
	"navButton": `Ourclients_navButton__7KV6P`,
	"prev": `Ourclients_prev__1-OJZ`,
	"next": `Ourclients_next__EDzKN`
};
export default ___CSS_LOADER_EXPORT___;
